import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable()
export class HttpBaseUrlInterceptor implements HttpInterceptor {
  intercept(
      req: HttpRequest<any>,
      next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Prepend base URL if the request URL is relative
    if (!req.url.startsWith('http')) {
      const apiReq = req.clone({
        withCredentials: true,
        url: `${environment.API_DOMAIN}${req.url}`,
      });
      return next.handle(apiReq);
    }
    return next.handle(req);
  }
}
